export const BRAND = {
  name: 'Kundlistar Studio',
  alternateNames: ['Kundlistar Studio', 'Kundlistar'],
  domain: 'kundlistarstudio.com',
  url: 'https://kundlistarstudio.com',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kundlistar.studio',
  appStoreUrl: 'https://apps.apple.com/in/app/kundlistar-studio/id6789635522',
  logoUrl: 'https://kundlistarstudio.com/logo.png',
  tagline: 'Personal Astrology Workspace',
  fullTitle: 'Kundlistar Studio - Personal Astrology Workspace',
};
